module.exports = __webpack_public_path__ + "img/flags/NF.f036025.png";